module.exports = __webpack_public_path__ + "img/ciec-loading.0b662acc.svg";